import * as actionTypes from '../actions/actionTypes';

const initialState  = {
  navigationItems: [],
  textBlocks: [],
  // staffList: [],
  // calendar: [],
  schedule: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_NAVIGATION:
      return {
        ...state,
        navigationItems: action.payload
      };
    case actionTypes.SET_SCHEDULE:
      return {
        ...state,
        schedule: action.payload
      };
/*
    case actionTypes.SET_STAFF:
      return {
        ...state,
        staffList: action.payload
      };
    case actionTypes.SET_CALENDAR:
      return {
        ...state,
        calendar: action.payload
      };
    case actionTypes.SET_TEXT_BLOCKS:
      return {
        ...state,
        textBlocks: action.payload
      };
      */
    default:
      return  state;
  }
};

export default reducer;
